<template>
  <div>
    <div ref="widgetContainer">
      <Row class="widget-container">
        <i-col :lg="24" :md="24" :sm="24" :xs="24">
          <LeadProcessed></LeadProcessed>
        </i-col>
      </Row>
    </div>
  </div>
</template>

<script>
  import LeadProcessed from './_LeadsProcessed'
  export default {
    name: 'LeadsProcessed',
    components: {
      LeadProcessed
    },
    data() {
      return {}
    },
    computed: {},
    watch: {},
    methods: {},
    mounted() {
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/c_LeadsProcessed/LeadsProcessed.vue